import { useCallback, useState } from "react";
import TaskColumn from "./TaskColumn";
import { Button, Empty } from "antd";
import httpClient from "../../../../api/httpClient";

const Board = ({ columns, setColumns, setSelectedColumn }) => {
  const [dragInfo, setDragInfo] = useState(null);

  const handleDragStart = useCallback((taskId, sourceColumnId, sourceIndex) => {
    setDragInfo({ taskId, sourceColumnId, sourceIndex });
  }, []);

  const handleDrop = useCallback(
    async (targetColumnId, targetIndex) => {
      if (!dragInfo) return;
      const { taskId, sourceColumnId, sourceIndex } = dragInfo;

      const next = JSON.parse(JSON.stringify(columns));

      const insertIndex = targetIndex ?? columns[targetColumnId].tasks.length;

      if (
        sourceColumnId === targetColumnId &&
        (sourceIndex === insertIndex ||
          (targetIndex === null &&
            sourceIndex === columns[targetColumnId].tasks.length - 1))
      ) {
        setDragInfo(null);
        return;
      }
      const sourceTask = next[sourceColumnId].tasks[sourceIndex];
      next[sourceColumnId].tasks.splice(sourceIndex, 1);

      next[targetColumnId].tasks.splice(insertIndex, 0, sourceTask);

      setColumns(next);

      setDragInfo(null);

      await httpClient.post("update-task-index", {
        task_id: taskId,
        new_column_id: targetColumnId,
        new_index: targetIndex ?? columns[targetColumnId].tasks.length,
      });
    },
    [dragInfo, columns],
  );

  return (
    <div className="tasks-board">
      {Object.values(columns).length > 0 ? (
        Object.values(columns).map((column) => (
          <TaskColumn
            key={column.id}
            column={column}
            dragInfo={dragInfo}
            onDragStart={handleDragStart}
            onDrop={handleDrop}
            setSelectedColumn={setSelectedColumn}
          />
        ))
      ) : (
        <div className="flex-center h-100 not-found">
          <Empty description="No columns found">
            <Button type="primary" onClick={() => setSelectedColumn({})}>
              Create Column
            </Button>
          </Empty>
        </div>
      )}
    </div>
  );
};

export default Board;
